// extracted by mini-css-extract-plugin
export default {"container":"contactPage_container__rMwBW","content":"contactPage_content__I8NEm"};